// extracted by mini-css-extract-plugin
export default {"bodyHidden":"ScrollLock__bodyHidden___MAhrc"};